export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/performance/wage_job_title',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/performance/wage_job_title',
      method: 'POST'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/performance/wage_job_title/{id}',
      method: 'PUT'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/performance/wage_job_title/{id}',
      method: 'DELETE'
    }]
  }
}